import { NativeService } from './../../../services/native.service';
import { FieldModel } from 'app/models/shared/field.model';
import { VehicleModel } from 'app/models/dms/vehicle.model';
import { GeneralService } from 'app/services/general.service';
import { LookupType, LookupExternalCollection, LookupInternalCollection } from 'app/utility/enums';
import { SelectListModalComponent } from './select-list-modal.component';
import { Component, OnInit, OnChanges, EventEmitter, Input, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { Constants } from 'app/utility/constants';
import { ModalController } from '@ionic/angular';
import { CountryModel } from 'app/models/shared/lookup.model';

@Component({
	selector: 'app-select-list',
	templateUrl: './select-list.component.html',
	styleUrls: ['./select-list.component.scss'],
	standalone: false
})
export class SelectListComponent implements OnInit, OnChanges
{

	@Input() id: string = '';
	@Input() label: string = '';

	@Input() active: boolean = false;
	@Input() disabled: boolean = false;

	/* standard inputs usage */
	@Input() selectedItemId: string; //the id of the selected value
	@Input() selectedValue: string; //the label to show for selected value
	@Input() defaultItemId: string; //default value id
	@Input() showBoxes: boolean = false;
	@Input() displayType: string;

	/* preloaded list usage */
	@Input() items: ListItemModel[];
	@Input() selectAllLabel: string;
	@Input() field: FieldModel;

	/* Output */
	@Output() selectedItemIdChange: EventEmitter<string> = new EventEmitter<string>();
	@Input() isBoolType: boolean = false;  //for boolean selections

	public loading: boolean = false;

	public lookupType: LookupType;
	public lookupCollection: string;

	public selectedItem: ListItemModel;
	public canAddNew: boolean = false;
	public allowClear: boolean = false;

	//side load for lazy loading
	@Input() sideload: any;  //this should be a list of lookups (by default, an empty guid item should exist)

	constructor(public modalController: ModalController,
		protected nativeService: NativeService,
		protected cd: ChangeDetectorRef,
		protected generalService: GeneralService

	)
	{
	}

	ngOnInit()
	{
		this.configureSelectedItem();
	}

	protected configureSelectedItem()
	{
		if (this.selectedItemId && this.items)
		{
			// console.log(this.label, "item: " + this.selectedItemId, this.items);
			for (let itemIndex in this.items)
			{
				let item = this.items[itemIndex];
				if (item.id == this.selectedItemId)
				{
					this.selectedItem = item;
					break;
				}
			}
		}
	}

	ngOnChanges(changes: SimpleChanges)
	{
		let hasNewItems: boolean = (changes != null && changes.items != null);
		let hasNewId: boolean = (changes != null && changes.selectedItemId != null);

		var newId = hasNewId ? changes.selectedItemId.currentValue : this.selectedItemId;
		var newItems = hasNewItems ? <ListItemModel[]>changes.items.currentValue : this.items;

		if (newItems)
		{
			for (let itemIndex in newItems)
			{
				var item = newItems[itemIndex];
				item._class = item.name ? item.name.toLowerCase().replace(/[^a-z]/g, '').replace(/ /g, '-') : '';
			}
		}
		if (newItems && newId)
		{
			var newSelected = newItems.filter(x => x.id == newId);
			if (newSelected.length == 1)
			{
				this.setSelectedItem(newSelected[0], false);
			}
			else
			{
				//  console.log("new selected", newItems, newId)
				this.clearSelectedItem();
			}
		}
		else if (newId)
		{
			if (this.items)
			{
				var newSelected = this.items.filter(x => x.id == newId);
				if (newSelected.length == 1)
				{
					this.setSelectedItem(newSelected[0], false);
				}
				else
				{
					this.clearSelectedItem();
				}
			}
		}

		if (!this.canActivate())
		{
			this.active = false;
		}
	}

	canActivate(): boolean
	{
		// console.log("canActivate", this.disabled, this.items, this.items.length, this.loading);
		if (!this.disabled && this.items && this.items.length >= 0 && !this.loading)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	getDisplayType(): string
	{
		if (this.displayType)
		{
			if (this.displayType == 'compact' ||
				this.displayType == 'label' ||
				this.displayType == 'inline' ||
				this.displayType == 'boxy' ||
				this.displayType == 'content')
			{
				return this.displayType;
			}
		}

		return 'full';
	}

	show(): void
	{
		if (this.field && this.field.editable == false)
		{
			return;
		}
		if (this.canActivate()) this.showModal();
	}

	async showModal()
	{
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");
		let allowAdd = (this.field && this.field.allowAdd);
		const modal = await this.modalController.create({
			component: SelectListModalComponent,
			componentProps: {
				'id': this.id,
				'title': this.label,
				'items': this.items,
				'selectAllLabel': this.selectAllLabel,
				'selectedValue': this.selectedValue,
				'selectedItemId': this.selectedItemId,
				'selectedItem': this.selectedItem,
				'showBoxes': this.showBoxes,
				'displayType': this.displayType,
				allowAdd
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);

		// console.log(data);
		if (data && this.field && ((this.field.allowAdd && data.caption) || (this.field.allowAddCode && data.code)))
		{
			this.addNewLookup(data);
		}
		else if (data && data.selectedItem)
		{
			this.setSelectedItem(data.selectedItem, true);
		}
	}

	setSelectedItem(item: ListItemModel, emit: boolean): void
	{
		if (this.selectedItem != item)
		{
			this.selectedItem = item;
			this.selectedItemId = item.id;
			if (this.field)
			{
				this.field.editValue = item.id;
				this.field.editCaption = item.name;
			}
			if (emit)
			{
				this.selectedItemIdChange.emit(item.id);
			}
			this.cd.detectChanges();
		}

	}

	clearSelectedItem(): void
	{
		// console.log("clear selected item called");
		this.selectedItem = null;
		if (this.defaultItemId && this.defaultItemId !== '')
		{
			this.selectedItemId = this.defaultItemId;
		}
		else
		{
			this.selectedItemId = Constants.EmptyGuid;
		}
	}

	defaultValue(): boolean
	{
		var defaultvalue = this.defaultItemId && this.defaultItemId !== '' && ((!this.selectedItem) || this.selectedItemId == this.defaultItemId);
		return defaultvalue;
	}

	getDisplayValue(): string
	{
		return (this.selectedItem) ? this.selectedItem.name : '-';
	}



	itemHasValue()
	{
		return (this.selectedItem && this.selectedItem.name.trim() != '');
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}


	protected async addNewLookup(data: any)
	{
		if (this.loading) return;

		// console.log(data);
		var endpoint = '';
		this.loading = true;

		switch (this.field.id)
		{
			case "physicalCountryId":
			case "postalCountryId":
				var country = new CountryModel();
				if (data.caption) country.name = data.caption;
				if (data.code) country.code = data.code;

				this.generalService.saveCountry(country).subscribe({
					next: x =>
					{
						this.selectedValue = x.name;
						this.selectedItem = new ListItemModel(x.countryId, x.name);
						this.items.push(this.selectedItem);
						this.setSelectedItem(this.selectedItem, true);
						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
							this.generalService.getCachedCountries(true);
						}, 0);
					},
					error: (error) =>
					{
						setTimeout(() =>
						{
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
						console.error(`Add new lookup failed`, data.caption);
					}
                });
				break;
			default:
				throw `Add lookup for lookup type, ${this.lookupType}, not supported`;
				break;
		}

		console.debug(`Add new lookup`, data.caption);

		this.loading = true;
		this.cd.detectChanges();


		// 	x =>
		// 	{
		// 		// console.debug(`findOrCreateExternalLookupCached`, x);
		// 		const item = new ListItemModel(x.id, x.caption);
		// 		this.setSelectedItem(item, true);
		// 		this.sideload.id  = x.id;
		// 		this.sideload.caption = x.caption;
		// 		this.loadLookupItems(true, false);

		// 		setTimeout(() => {
		// 			this.loading = false;
		// 			this.cd.detectChanges();
		// 		}, 0);
		// 	},
		// 	err =>
		// 	{
		// 		setTimeout(() => {
		// 			this.loading = false;
		// 			this.cd.detectChanges();
		// 		}, 0);
		// 		console.error(`Add new lookup failed`, data.caption);
		// 	}
		// );
	}


	public codeLookupList: ListItemModel[] = [];
	loadBaseInternalLookup(loadModal: boolean)
	{
		this.generalService
			.getInternalLookups(<LookupInternalCollection>this.sideload.lookupInternal.collection)
			.subscribe
			({
				next: x =>
				{
					this.codeLookupList = x.map<ListItemModel>(y => new ListItemModel(y.member.toString(), y.caption));

					if (loadModal)
					{
						this.showModal();
					}

					setTimeout(() =>
					{
						this.loading = false;
						this.cd.detectChanges();
					}, 0);
				},
				error: err =>
				{

					setTimeout(() =>
					{
						this.loading = false;
						this.cd.detectChanges();
					}, 0);
					console.error(`loadParentInternalLookup`, err);
				}
			});
	}
}
